const defaultLocaleText = {
  error: {
    invalidFormat: "The value is invalid"
  }
};
export {
  defaultLocaleText
};
//# sourceMappingURL=defaultLocaleText.js.map
